import { FIELD_TYPES, VALIDATION_RULE } from "./constants";

export default class FormDataValidator {
    
    static validate(currentField, allFields){
        if(currentField?.Type){
            switch(currentField.Type){
                case FIELD_TYPES.STRING:
                case FIELD_TYPES.TEXTAREA:
                case FIELD_TYPES.DATE:
                case FIELD_TYPES.ENUM:
                case FIELD_TYPES.BOOLEAN:
                case FIELD_TYPES.FREEHANDDRAW:
                case FIELD_TYPES.CURRENCY:
                case FIELD_TYPES.MULTISELECTENUM: 
                case FIELD_TYPES.RADIO:
                case FIELD_TYPES.ENUM_MODAL:
                case FIELD_TYPES.FILE_UPLOAD:
                    return this._validateFieldType(currentField, allFields);
                default: 
                    return { isError: false, errorMessage: "" }
            }
        }else{
            return { isError: false, errorMessage: "" }
        }
    }

    static _required(currentFieldValue, currentField) {
        if (!currentFieldValue || (currentField?.Type === FIELD_TYPES.BOOLEAN && currentFieldValue == "false") || currentFieldValue.toString().trim() === "") {
            return false;
        }
        return true;
    }

    static _isNumeric(currentFieldValue){
        const numericRegex = /^(\d+|\d*\.\d+)$/;
        return currentFieldValue === undefined || currentFieldValue === '' || numericRegex.test(currentFieldValue);
    }

    static _maxXPercentOf(currentFieldValue, dependentFieldId, targetValue, allFieldsArr){
        if(currentFieldValue === "" || currentFieldValue === undefined){
            return true;
        }
        const dependentFieldIds = (dependentFieldId && dependentFieldId.split(',').map(id => id.trim())) ?? [];
        const dependentFields = allFieldsArr.filter(item => dependentFieldIds.includes(item?.Name));
        const totalInputValue = dependentFields.reduce((total, field) => {
            if (field.inputValue !== undefined && field?.inputValue !== "") {
                let fieldValue = parseFloat(field?.inputValue)
                if(!fieldValue){
                    fieldValue = 0
                }
                return total + fieldValue;
            }
            return total;
        }, 0);
        const percent = ((currentFieldValue / totalInputValue) * 100).toFixed(2);

        if (percent > targetValue) {
            return false;
        }
        return true;
    }

    static _regularExpression(currentFieldValue, pattern) {

        if (!pattern) {
            return true;
        }

        if(!currentFieldValue){
            currentFieldValue = "";
        }

        try {
            const regex = new RegExp(pattern);
            return regex.test(currentFieldValue);
        } catch (error) {
            console.error("Invalid regular expression:", error);
            return false;
        }
    }

    static _validateLength(currentFieldValue, minLength, maxLength) {
        const strInput = String(currentFieldValue);
        const length = strInput.length;
        if (length < minLength || length > maxLength) {
            return false;
        }
        return true;
    }

    static _shouldBeLessThan(currentValue, value) {
        if (currentValue === undefined || currentValue === null || currentValue === '') {
            return true;
        }
        return currentValue < value;
    }

    static _valueCompare(currentFieldValue, dependentFieldId, compareOperator, allFieldsArr) {
        if((!currentFieldValue || currentFieldValue == '') && (compareOperator == '<' || compareOperator == '<=')){
            return true;
        }
        const dependentField = allFieldsArr.find(field => field?.Name === dependentFieldId);
        if (dependentField) {
            if (dependentField.hasOwnProperty('inputValue')) {
                let dependentValue = parseFloat(dependentField?.inputValue);
                let currentValue = parseFloat(currentFieldValue);
                if (isNaN(dependentValue)) {
                    dependentValue = 0;
                }
                
                if (isNaN(currentValue)) {
                    currentValue = 0;
                }
                switch (compareOperator) {
                    case '>':
                        return currentValue > dependentValue;
                    case '<':
                        return currentValue < dependentValue;
                    case '<=':
                        return currentValue <= dependentValue;
                    case '>=':
                        return currentValue >= dependentValue;
                    case '==':
                        return currentValue == dependentValue;
                    default:
                        return false;
                }
            } else {
                return false;
            }
        }
        return false;
    }

    static _notRequiredIfFieldFilled(currentField, dependentFieldId, targetValue, allFieldsArr) {

        if(currentField?.Type === FIELD_TYPES.BOOLEAN && currentField?.inputValue === true){
            return true
        }else if(currentField?.Type !== FIELD_TYPES.BOOLEAN && (currentField?.inputValue ?? "").toString().trim() !== ""){
            return true
        }

        const dependentField = allFieldsArr.find(field => field?.Name === dependentFieldId);
        if (dependentField) {
            if (dependentField.hasOwnProperty('inputValue')) {
                const dependentValue = dependentField?.inputValue;
                if (targetValue === FIELD_TYPES.BOOLEAN && (dependentValue === true || dependentValue === 'true')) {
                    return true;
                } else if (targetValue !== FIELD_TYPES.BOOLEAN && dependentValue.toString().trim() !== ''){
                    return true;
                }
            }
        }

        if (!currentField?.inputValue) {
            return false;
        }
        return false;
    }

    static _notRequiredIfMultiFieldFilled(currentField, dependentFieldIds, targetValue, allFieldsArr) {
        if (currentField?.Type === FIELD_TYPES.BOOLEAN && currentField?.inputValue === true) {
            return true;
        } else if (currentField?.Type !== FIELD_TYPES.BOOLEAN && (currentField?.inputValue ?? '').toString().trim() !== '') {
            return true;
        }
    
        const dependentIdsArr = dependentFieldIds.split(',');
    
        for (const dependentFieldId of dependentIdsArr) {
            const dependentField = allFieldsArr.find(field => field?.Name === dependentFieldId);
            if (dependentField) {
                if (dependentField.hasOwnProperty('inputValue')) {
                    const dependentValue = dependentField?.inputValue;
                    if (dependentField?.Type === FIELD_TYPES.BOOLEAN && (dependentValue === true || dependentValue === 'true')) {
                        return true;
                    } else if (dependentField?.Type !== FIELD_TYPES.BOOLEAN && dependentValue.toString().trim() !== '') {
                        return true;
                    }
                }
            }
        }
    
        return false;
    }

    static _requiredIfFieldFilled(currentField, dependentFieldId, targetValue, allFieldsArr) {

        if(currentField?.Type === FIELD_TYPES.BOOLEAN && currentField?.inputValue === true){
            return true
        }else if(currentField?.Type !== FIELD_TYPES.BOOLEAN && (currentField?.inputValue ?? "").toString().trim() !== ''){
            return true
        }

        const dependentField = allFieldsArr.find(field => field?.Name === dependentFieldId);
        if (dependentField) {
            if (dependentField.hasOwnProperty('inputValue')) {
                const dependentValue = dependentField?.inputValue;
                if (dependentField?.Type === FIELD_TYPES.BOOLEAN && (dependentValue === true || dependentValue === 'true')) {
                    if (!currentField?.inputValue) {
                        return false;
                    }
                } else if (dependentField?.Type !== FIELD_TYPES.BOOLEAN && dependentValue.toString().trim() !== ''){
                    if (!currentField?.inputValue) {
                        return false;
                    }
                }
            }
        }
        return true;
    }

    static _atLeastOneFieldRequired(currentField, dependentFieldsArr, allFieldsArr) {
        
        if(currentField?.Type === FIELD_TYPES.BOOLEAN && currentField?.inputValue === true){
            return true
        }else if(currentField?.Type !== FIELD_TYPES.BOOLEAN && (currentField?.inputValue ?? "").toString().trim() !== ""){
            return true
        }
        for (let i = 0; i < dependentFieldsArr.length; i++) {
            const dependentField = allFieldsArr.find(field => field?.Name === dependentFieldsArr[i]);

            if (dependentField) {
                if (dependentField.hasOwnProperty('inputValue')) {
                    const dependentValue = dependentField?.inputValue;
                    if (dependentField?.Type === FIELD_TYPES.BOOLEAN && (dependentValue === true || dependentValue === 'true')) {
                        return true;
                    } else if (dependentField?.Type !== FIELD_TYPES.BOOLEAN && dependentValue.toString().trim() !== ''){
                        return true;
                    }
                }
            }
        }
        return false;
    }
      
      
    static _validateFieldType(currentField, allFields) {
        if (currentField?.Validations) {
            for (let rule in currentField.Validations) {
                let validationResult = { isError: false, errorMessage: "" };

                switch (rule) {
                    case VALIDATION_RULE.REQUIRED:
                        if (!this._required(currentField?.inputValue, currentField)) {
                            validationResult = {
                                isError: true,
                                errorMessage:
                                    currentField.Validations[rule]?.ErrorMessage ?? "",
                            };
                        }
                        break;

                    case VALIDATION_RULE.MAXXPERCENTOF:
                        if (
                            !this._maxXPercentOf(
                                currentField?.inputValue,
                                currentField.Validations[rule]?.DependentProperty,
                                currentField.Validations[rule]?.TargetValue,
                                allFields
                            )
                        ) {
                            validationResult = {
                                isError: true,
                                errorMessage:
                                    currentField.Validations[rule]?.ErrorMessage ?? "",
                            };
                        }
                        break;

                    case VALIDATION_RULE.STRINGLENGTH:
                        if (!this._validateLength(currentField?.inputValue, currentField?.Validations[rule]?.Minimum, currentField?.Validations[rule]?.Maximum)) {
                            validationResult = {
                                isError: true,
                                errorMessage:
                                    currentField.Validations[rule]?.ErrorMessage ?? "",
                            };
                        }
                        break;

                    case VALIDATION_RULE.NUMERIC:
                        if (!this._isNumeric(currentField?.inputValue)) {
                            validationResult = {
                                isError: true,
                                errorMessage:
                                    currentField.Validations[rule]?.ErrorMessage ?? "",
                            };
                        }
                        break;
                        
                    case VALIDATION_RULE.REGULAREXPRESSION:
                        if (
                            !this._regularExpression(
                                currentField?.inputValue ?? "",
                                currentField.Validations[rule]?.Pattern
                            )
                        ) {
                            validationResult = {
                                isError: true,
                                errorMessage:
                                    currentField.Validations[rule]?.ErrorMessage ?? "",
                            };
                        }
                        break;

                    case VALIDATION_RULE.NOTREQUIREDIFFIELDFILLED:
                        if (!this._notRequiredIfFieldFilled(currentField, 
                            currentField.Validations[rule]?.DependentProperty, 
                            currentField.Validations[rule]?.TargetValue, 
                            allFields
                            )) {
                            validationResult = {
                                isError: true,
                                errorMessage:
                                    currentField.Validations[rule]?.ErrorMessage ?? "",
                            };
                        }
                        break;

                    case VALIDATION_RULE.NOTREQUIREDIFMULTIFIELDFILLED:
                        if (!this._notRequiredIfMultiFieldFilled(currentField, 
                            currentField?.Validations[rule]?.DependentProperty, 
                            currentField?.Validations[rule]?.TargetValue, 
                            allFields
                            )) {
                            validationResult = {
                                isError: true,
                                errorMessage:
                                    currentField?.Validations[rule]?.ErrorMessage ?? "",
                            };
                        }
                        break;

                    case VALIDATION_RULE.REQUIREDIFFIELDFILLED:
                        if (!this._requiredIfFieldFilled(currentField, 
                            currentField.Validations[rule]?.DependentProperty, 
                            currentField.Validations[rule]?.TargetValue, 
                            allFields
                            )) {
                            validationResult = {
                                isError: true,
                                errorMessage:
                                    currentField.Validations[rule]?.ErrorMessage ?? "",
                            };
                        }
                        break;

                    case VALIDATION_RULE.ATLEASTONEFIELDREQUIRED:
                        if (!this._atLeastOneFieldRequired(currentField, 
                            currentField.Validations[rule]?.FieldNames,
                            allFields
                            )) {
                            validationResult = {
                                isError: true,
                                errorMessage:
                                    currentField.Validations[rule]?.ErrorMessage ?? "This field is required",
                            };
                        }
                        break;

                    case VALIDATION_RULE.SHOULDBELESSTHAN:
                        if (!this._shouldBeLessThan(currentField?.inputValue, currentField.Validations[rule]?.Value)) {
                            validationResult = {
                                isError: true,
                                errorMessage:
                                    currentField.Validations[rule]?.ErrorMessage ?? "",
                            };
                        }
                        break;

                    case VALIDATION_RULE.VALUECOMPARE:
                        if (!this._valueCompare(currentField?.inputValue, 
                            currentField.Validations[rule]?.DependentProperty, 
                            currentField.Validations[rule]?.CompareOperator, 
                            allFields
                            )) {
                            validationResult = {
                                isError: true,
                                errorMessage:
                                    currentField.Validations[rule]?.ErrorMessage ?? "",
                            };
                        }
                        break;
                }

                if (validationResult.isError) {
                    return validationResult;
                }
            }
            return { isError: false, errorMessage: "" };
        } else {
            return { isError: true, errorMessage: "Invalid entry. Please try again" };
        }
    }
}